import React, { useCallback, useEffect, useState } from 'react';
import CustomBreadcrumbs from '../../../../../../common/components/custombreadcrumbs/CustomBreadcrumbs';
import {
  Box,
  Typography,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  Dialog,
  Divider,
  Switch
} from '@mui/material';
import { Icon } from '@iconify/react';
import CustomDataGrid from '../../../../../../common/components/customized/customdatagrid/CustomDataGrid';
import nodata from '../../../../../../app/assets/images/nodata.png.png';
import { useAppDispatch, useAppSelector } from '../../../../../../app/redux/hooks';
import UpdateScheduleTrip from '../UpdateScheduleTrip';
import CustomButton from '../../../../../../common/components/buttons/CustomButton';
import UpdateGeneratedTrip from '../UpdateGeneratedTrip';
import {
  capitalizeFirstLetter,
  convertTo12HourFormat,
  debounce,
  usePagination
} from '../../../../../../utils/commonFunctions';
import CustomIconButton from '../../../../../../common/components/buttons/CustomIconButton';
import CustomTextField from '../../../../../../common/components/customized/customtextfield/CustomTextField';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { Controller, useForm } from 'react-hook-form';
import PhoneNoTextField from '../../../../../../common/components/customized/customtextfield/PhoneNoTextField';
import CustomSelect from '../../../../../../common/components/customized/customselect/CustomSelect';
import * as yup from 'yup';
import CustomRadioButton from '../../../../../../common/components/customized/customradiobutton/CustomRadioButton';
import { yupResolver } from '@hookform/resolvers/yup';
import AddExternalVehicle from './AddExternalVehicle';
import {
  autoGeneratedTripsAction,
  autoGenerateUpdateTripsAction,
  deleteSchedule,
  deleteScheduleBooking,
  driverDropdownAction,
  getScheduleDriverAction,
  getStandardVehicles,
  scheduleTripsAction,
  switchTripsAction
} from '../../../../redux/reducer/autoPlannerSlices/autoGenerateSlice';
import { GridActionsCellItem } from '@mui/x-data-grid';
import constant from '../../../../../../utils/constants';

interface Props {
  scheduleDate: number;
  checked: any;
  setBreadCrumbs: any;
  setVehicles: any;
  tripPayloads: any;
  agent: any;
  guest: any;
  tour: any;
  vehicle: any;
  initialLoad: boolean;
  setPayload: any;
}

interface Column {
  field: string;
  headerName: string;
  minWidth: number;
  flex: number;
  renderCell?: (params: { row: any }) => any;
  textAlign?: string;
}

interface SwitchColumn {
  field: string;
  headerName: string;
  minWidth: number;
  flex: number;
  align?: string;
  renderCell?: (params: { row: any }) => any;
  textAlign?: string;
}

interface PaginationModel {
  page: number;
  pageSize: number;
}

interface Driver {
  driverID: string;
  driverName: string;
}

const ScheduledSic = ({
  scheduleDate,
  checked,
  setBreadCrumbs,
  setVehicles,
  initialLoad,
  tripPayloads,
  agent,
  guest,
  tour,
  vehicle,
  setPayload
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = useState<any | null>(null);
  const [tripData, setTripData] = useState<any[]>([]);
  const [filterPayload, setFilterPayload] = useState<any>('');
  const [only, setOnly] = React.useState(false);
  const [prevSearch, setPrevSearch] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [scheduleData, setScheduleData] = useState<any[]>([]);
  const [switchData, setSwitchData] = useState<any>([]);
  const [view, setView] = useState<boolean>(false);
  const [isDialog, setIsDialog] = useState('');
  const [bookingUpdate, IsbookingsUpdate] = useState(false);
  const [selectedTripRow, setSelectedTripRow] = useState<any | null>(null);
  const [switchRow, setSwitchRow] = useState<any | null>(null);
  const [transRow, setTransRow] = useState<any | null>(null);
  const [driverPayload, setDriverPayload] = useState<any | null>(null);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [external, setExternal] = useState<boolean>(true);
  const [seatCapacity, setSeatCapacity] = useState<any>(0);
  const [isDrag, setIsDrag] = useState<boolean>(false);
  const [vehilceRows, setVehilceRows] = useState<any | any[]>([]);
  const [filter, setFilter] = useState('');
  const [PageSize, setPageSize] = useState(20);
  const [PageNo, setPageNo] = useState(1);
  const [tripPayload, setTripPayload] = useState({ PageNo, PageSize });
  const [scheduledPayload, setScheduledPayload] = useState({
    autoplannerID: scheduleDate
  });
  const openMenu = Boolean(anchorEl);

  const reportData = useAppSelector(state => state.AutoGeneratedTrip);
  const transferDrivers = useAppSelector(state => state.Driverdrop || []);
  const { isLoading: getAllLoading } = useAppSelector(state => state.AutoGeneratedTrip);
  const { isLoading: driverLoading } = useAppSelector(
    state => state.AutoGeneratedUpdateTrip
  );
  const scheduledData = useAppSelector(state => state.scheduleTrip);
  const {
    data,
    count,
    isFilter,
    isLoading: switchTripLoading
  } = useAppSelector(state => state.switchTrip);

  const { isLoading: autoBookingsLoading } = useAppSelector(state => state.scheduleTrip);
  const { isLoading } = useAppSelector(state => state.deleteSchedule);
  const Agents = useAppSelector(state => state.autoPlannerAgent.data || []);
  const { data: role } = useAppSelector(state => state.auth);
  const Routes = useAppSelector(state => state.autoPlannerRoutes.data || []);
  const { isLoading: deleteLoading } = useAppSelector(
    state => state.deleteScheduleBooking
  );
  const { isLoading: vehicleLoading, data: vehicleListData } = useAppSelector(
    state => state.getStandardVehicles
  );

  let roletype = role?.role;
  const roleAgent = roletype === 'ROLE_AGENT';

  const dispatch = useAppDispatch();
  const { pageSize, pageNo, pagination } = usePagination(20);

  const tripSchema = () =>
    yup.object().shape({
      vehicle: yup
        .string()
        .oneOf(['internal', 'external'])
        .required('Select vehicle type'),

      search: yup.string().notRequired(),
      vehicleNumber: yup.string().when('vehicle', {
        is: 'internal',
        then: () => yup.string().required('Select vehicle number'),
        otherwise: () => yup.string().required('Select vehicle number')
      }),
      driverName: yup.string().when('vehicle', {
        is: 'external',
        then: () => yup.string().required('Enter Driver Name'),
        otherwise: () => yup.string().notRequired()
      }),
      passengerCount: yup.string().when('vehicle', {
        is: 'external',
        then: () =>
          yup
            .number()
            .required('Enter Seat Capacity')
            .min(
              selectedRow?.netCount ? selectedRow?.netCount : 1,
              `Seat Capacity Must be Minimum ${selectedRow?.netCount}`
            )
            .typeError(`Seat Capacity Must be Minimum ${selectedRow?.netCount}`),
        otherwise: () => yup.string().notRequired()
      }),
      driverNumber: yup.string().when('vehicle', {
        is: 'external',
        then: () => yup.string().required('Enter Contact Number'),
        otherwise: () => yup.string().notRequired()
      })
    });

  const hotelLocationList = selectedTripRow
    ? selectedTripRow?.mainHotelResponses?.map((item: any) => ({
        id: item.coordinates.locationAddress,
        label: item.coordinates.locationAddress
      }))
    : transRow
    ? transRow?.mainHotelResponses?.map((item: any) => ({
        id: item?.coordinates.locationAddress,
        label: item?.coordinates.locationAddress
      }))
    : [];

  const vehicleList = vehicleListData?.map((item: any) => ({
    id: item,
    label: item?.toUpperCase()
  }));

  const Driver = () =>
    yup.object().shape({
      driver: yup.string().required('Select Driver Name')
    });

  const { control, setValue, clearErrors, handleSubmit } = useForm({
    resolver: yupResolver(tripSchema())
  });

  const {
    control: driverControl,
    handleSubmit: driverHandleSubmit,
    reset
  } = useForm({
    resolver: yupResolver(Driver())
  });

  const configuredRoute =
    Routes?.map((value: string) => ({
      id: value,
      label: value
    })) || [];

  const agentNames =
    Agents?.map((value: string) => ({
      id: value,
      label: capitalizeFirstLetter(value)
    })) || [];

  const dropDriver =
    transferDrivers?.data?.map((driver: any) => ({
      id: driver.driverID,
      label: capitalizeFirstLetter(driver.driverName)
    })) || [];

  const payload = {
    ...scheduledPayload,
    PageNo: 1,
    PageSize: 20,
    autoplannerID: scheduleDate,
    tripMode: 'SIC'
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleUpdateGroupTrip = () => {
    setIsUpdate(true);
    handleMenuClose();
  };

  const handleViewTrip = async (row: any) => {
    setView(true);
    if (row !== null) {
      const payload = {
        mode: 'SIC',
        date: scheduleDate,
        tourName: row.tourName,
        vehicleNumber: row.vehicleNumber,
        id: row.id,
        isReturnTrip: row.isReturnTrip
      };
      await dispatch(scheduleTripsAction(payload));
    }
    handleMenuClose();
    setIsDialog('');
  };

  const handleMenuClick = (row: any) => {
    setSelectedRow(row);
  };

  const handleDriver = (row: any) => {
    setSelectedRow(row);
    const payload = {
      mode: 'SIC',
      date: scheduleDate,
      journeyID: row?.journeyId,
      vehicleNumber: row?.vehicleNumber,
      tourName: row?.tourName,
      modifyVehicleDriver: only ? 0 : 1,
      radio: only
    };
    setDriverPayload(payload);
    dispatch(driverDropdownAction(payload));
  };

  const handleMenuTripClick = (row: any) => {
    setSelectedTripRow(row);
  };

  const handleMenuSwitchTripClick = (event: React.MouseEvent<HTMLElement>, row: any) => {
    setAnchorEl(event.currentTarget);
    setSwitchRow(row);
  };

  const handleTransClick = (event: React.MouseEvent<HTMLElement>, row: any) => {
    setSelectedTripRow(null);
    setTransRow(row);
    setIsDialog('Transfer');
  };

  const handleUpdateTrip = () => {
    IsbookingsUpdate(true);
    handleMenuClose();
  };

  const handleSwitchUpdateTrip = () => {
    IsbookingsUpdate(true);
    handleMenuClose();
  };

  const handleAddTransfer = async (row: any) => {
    setIsDialog('addTransfer');
    setSelectedTripRow(row);
    const payload = {
      autoplannerID: scheduleDate,
      journeyId: row?.journeyId,
      tripMode: 'TRANSFER',
      totalPassengers: row?.totalCount,
      vehicleNumber: row?.vehicleNumber,
      tourName: row?.tourName
    };
    await dispatch(getStandardVehicles(payload));
  };

  const handleDelete = async () => {
    const payload = {
      mode: 'SIC',
      date: scheduleDate,
      id: selectedRow?.id
    };
    const payloadBookings = {
      date: scheduleDate,
      journeyId: selectedTripRow?.journeyId || selectedTripRow?.journeyID,
      mode: 'SIC',
      id: selectedRow?.id
    };
    const params = {
      autoplannerID: scheduleDate,
      tripMode: 'SIC',
      PageNo: PageNo,
      PageSize: PageSize
    };
    if (isDialog === 'Delete') {
      await dispatch(deleteSchedule(payload));
    } else if (isDialog === 'DeleteBooking') {
      await dispatch(deleteScheduleBooking(payloadBookings));
      if (selectedTripRow?.source) {
        await dispatch(switchTripsAction(params));
      } else {
        await dispatch(
          scheduleTripsAction({
            date: scheduleDate,
            mode: 'SIC',
            id: selectedRow?.id
          } as any)
        );
      }
    }
    setIsDelete(false);
    setIsDialog('');
  };

  const handleClose = () => {
    setAnchorEl(null);
    setTransRow(null);
    setExternal(false);
    setIsDialog('');
    reset();
  };

  //function for transfer update
  const handleUpdateTransfer = async () => {
    setIsDialog('addTransfer');
    const payload = {
      autoplannerID: scheduleDate,
      journeyId: transRow.journeyId,
      tripMode: 'TRANSFER',
      tourName: transRow?.tourName,
      totalPassengers: transRow?.totalCount,
      vehicleNumber: transRow?.vehicleNumber
    };

    await dispatch(getStandardVehicles(payload));
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setOnly(isChecked);
    const payload = {
      ...driverPayload,
      radio: isChecked
    };
    dispatch(driverDropdownAction(payload));
  };

  useEffect(() => {
    const filter = {
      autoplannerID: scheduleDate,
      tripMode: 'SIC',
      PageNo: PageNo,
      PageSize: PageSize,
      agentName: agent,
      guestName: guest,
      tourName: tour,
      vehicleNumber: vehicle
    };
    setFilterPayload(filter);
  }, [agent, guest, tour, vehicle]);

  const handleFilterChange = useCallback(
    debounce((event: string) => {
      setFilter(event);
      setPrevSearch(true);
      setBreadCrumbs((prev: any) => {
        return { ...prev, filter: event };
      });
      const payload = {
        ...tripPayloads,
        autoplannerID: scheduleDate,
        tripMode: 'SIC',
        PageNo: PageNo,
        PageSize: PageSize,
        searchFor: event,
        agentName: agent,
        guestName: guest,
        tourName: tour,
        vehicleNumber: vehicle
      };
      setFilterPayload(payload);
      dispatch(switchTripsAction(payload));
    }),
    [scheduleDate, agent, guest, tour, vehicle]
  );

  const handlePaginationModelChange = async (newPaginationModel: PaginationModel) => {
    const { pageSize: newPageSize, page: newPageNo } = newPaginationModel;
    setPageSize(newPageSize);
    setPageNo(newPageNo + 1);
    const newPage = newPageNo + 1;
    const payload = {
      ...tripPayload,
      ...tripPayloads,
      PageNo: newPage,
      PageSize: newPageSize,
      autoplannerID: scheduleDate,
      tripMode: 'SIC',
      searchFor: filter
    };
    setTripPayload(payload);
    if (checked && !view) await dispatch(autoGeneratedTripsAction(payload));
    else await dispatch(switchTripsAction(payload));
  };

  const onChangeDriverSubmit = async (params: any) => {
    const payload = {
      ...selectedRow,
      ...driverPayload,
      modifyVehicleDriver: only ? 0 : 1,
      driverID: params.driver
    };

    const pageDetails = {
      autoplannerID: scheduleDate,
      tripMode: 'SIC',
      id: selectedRow?.id
    };
    const data = { payload, pageDetails };

    if (checked) {
      await dispatch(autoGenerateUpdateTripsAction(data));
      handleClose();
    } else {
      const action = await dispatch(getScheduleDriverAction(payload));
      const paramss = { ...pageDetails, PageNo: 1, PageSize: 20 };
      if (action.type === getScheduleDriverAction.fulfilled.type) {
        handleClose();
        setSelectedTripRow(null);
        await dispatch(switchTripsAction(paramss));
        handleClose();
        reset();
      }
    }
  };
  const Incolumns: Column[] = [
    {
      field: 'actions',
      headerName: 'Action',
      type: 'actions',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      getActions: (params: any) => {
        const actions = [];

        if (!roleAgent) {
          actions.push(
            <GridActionsCellItem
              key='edit'
              icon={<Icon icon='ic:baseline-edit' className='menu-icon update' />}
              label={constant.Update}
              onClick={() => {
                handleMenuTripClick(params.row);
                handleUpdateTrip();
              }}
              showInMenu
            />
          );
        }

        return actions;
      }
    },
    { field: 'agentName', headerName: ' Agent Name', minWidth: 150, flex: 1 },
    {
      field: 'guestName',
      headerName: 'Guest Name',
      minWidth: 200,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    {
      field: 'guestContactNumber',
      headerName: 'Guest Contact Number',
      minWidth: 200,
      flex: 1,
      valueGetter: (params: any) => (params.value ? params.value : '-')
    },
    {
      field: 'source',
      headerName: 'Source',
      minWidth: 300,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    {
      field: 'destination',
      headerName: 'Destination',
      minWidth: 300,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    { field: 'time', headerName: 'Time', minWidth: 100, flex: 1 },
    { field: 'childCount', headerName: 'Child Count', minWidth: 120, flex: 1 },
    { field: 'adultCount', headerName: 'Adult Count', minWidth: 120, flex: 1 },
    {
      field: 'refNumber',
      headerName: 'Ref Number',
      minWidth: 150,
      flex: 1,
      renderCell: (params: any) => {
        const value = params.value;
        return value ? (
          <Tooltip title={value}>
            <span>{value}</span>
          </Tooltip>
        ) : (
          '-'
        );
      }
    },
    {
      field: 'vehicleNumber',
      headerName: 'Vehicle Number',
      minWidth: 150,
      flex: 1,
      renderCell: ({ value }: any) => value?.toUpperCase()
    },
    { field: 'driverName', headerName: 'Driver Name', minWidth: 150, flex: 1 },
    { field: 'mobileNumber', headerName: 'Contact Number', minWidth: 150, flex: 1 }
  ].map((item: any) => ({ ...item, sortable: false }));

  const switchColumns: SwitchColumn[] = [
    {
      field: 'actions',
      headerName: 'Action',
      type: 'actions',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      getActions: (params: any) => {
        const actions = [];

        if (!roleAgent) {
          actions.push(
            <GridActionsCellItem
              key='edit'
              icon={<Icon icon='ic:baseline-edit' className='menu-icon update' />}
              label={constant.Update}
              onClick={() => {
                handleMenuTripClick(params.row);
                handleUpdateTrip();
              }}
              showInMenu
            />
          );
        }

        return actions;
      }
    },

    { field: 'agentName', headerName: 'Agent Name', minWidth: 150, flex: 1 },
    { field: 'guestName', headerName: 'Guest Name', minWidth: 200, flex: 1 },
    {
      field: 'guestContactNumber',
      headerName: 'Guest Contact Number',
      minWidth: 200,
      flex: 1,
      valueGetter: (params: any) => (params.value ? params.value : '-')
    },
    {
      field: 'tourName',
      headerName: 'Tour Name',
      minWidth: 150,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    { field: 'childCount', headerName: 'Child Count', minWidth: 100, flex: 1 },
    { field: 'adultCount', headerName: 'Adult Count', minWidth: 100, flex: 1 },
    { field: 'totalCount', headerName: 'Total Count', minWidth: 100, flex: 1 },
    {
      field: 'refNumber',
      headerName: 'Ref Number',
      minWidth: 150,
      flex: 1,
      renderCell: (params: any) => {
        const value = params.value;
        return value ? (
          <Tooltip title={value}>
            <span>{value}</span>
          </Tooltip>
        ) : (
          '-'
        );
      }
    },
    {
      field: 'vehicleNumber',
      headerName: 'Vehicle Number',
      minWidth: 150,
      flex: 1,
      renderCell: ({ value }: any) => value?.toUpperCase()
    },
    {
      field: 'driverName',
      headerName: 'Driver Name',
      minWidth: 170,
      renderCell: (params: any) => {
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%'
            }}
          >
            {params.row.vehicleNumber != 'Unassigned' && !roleAgent && (
              <Icon
                icon='ph:user-switch'
                style={{
                  color: '#0ebc93',
                  cursor: 'pointer',
                  fontSize: '25px',
                  marginRight: '10px'
                }}
                className={'activeIcon'}
                onClick={event => {
                  event.stopPropagation();
                  setIsDialog('changeDriver');
                  handleDriver(params.row);
                }}
              />
            )}
            <Typography>{params.value}</Typography>
          </Box>
        );
      },
      flex: 1
    },
    {
      field: 'driverContactNumber',
      headerName: 'Contact Number',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'pickupWindow',
      headerName: 'Pickup Window',
      minWidth: 130,
      flex: 1,
      renderCell: (params: any) => {
        const value = params.value;
        return value ? (
          <Tooltip title={value}>
            <span>{value}</span>
          </Tooltip>
        ) : (
          '-'
        );
      }
    },
    {
      field: 'time',
      headerName: 'Return Time',
      minWidth: 100,
      flex: 1,
      renderCell: (params: any) => {
        const pickupWindow = params.row.pickupWindow;
        const timeStr = params.value;
        if (pickupWindow) return '-';
        if (!timeStr) return '-';
        let [hours, minutes] = timeStr.split(':').map(Number);
        let period = hours >= 12 ? 'PM' : 'AM';
        // Convert to 12-hour format
        hours = hours % 12 || 12;
        return `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
      }
      // renderCell: (params: any) => {
      //   const value = params.value;
      //   return value ? (
      //     <Tooltip title={value}>
      //       <span>{value}</span>
      //     </Tooltip>
      //   ) : (
      //     '-'
      //   );
      // }
    },
    {
      field: 'source',
      headerName: 'Source',
      minWidth: 300,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    {
      field: 'destination',
      headerName: 'Destination',
      minWidth: 300,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    {
      field: 'transfer',
      headerName: 'Transfer',
      minWidth: 150,
      align: 'center',
      flex: 1,
      renderCell: (params: any) => {
        const isDisabled = !params.row?.transferInstance && !roleAgent;

        return params?.row?.isReturnTrip ||
          params?.row?.mainHotelResponses?.length === 0 ? (
          'N/A'
        ) : (
          <Typography
            variant='body2'
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              color: '#fff',
              background: isDisabled
                ? 'linear-gradient(45deg, #66bb6a 30%, #43a047 90%)'
                : 'linear-gradient(45deg, #42a5f5 30%, #1e88e5 90%)',
              padding: '4px 10px',
              borderRadius: '20px',
              fontWeight: 'bold',
              textAlign: 'center',
              fontSize: '13px',
              minHeight: '24px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease',
              '&:hover': {
                background: isDisabled
                  ? 'linear-gradient(45deg, #43a047 30%, #66bb6a 90%)'
                  : 'linear-gradient(45deg, #1e88e5 30%, #42a5f5 90%)',
                transform: 'scale(1.1)',
                boxShadow: '0 6px 10px rgba(0, 0, 0, 0.2)'
              },
              '&:active': {
                transform: 'scale(1.05)'
              }
            }}
            onClick={event => {
              if (isDisabled) {
                handleAddTransfer(params?.row);
              } else {
                handleTransClick(event, params.row);
              }
            }}
          >
            {isDisabled ? 'Add Transfer' : 'Transfer Details'}
          </Typography>
        );
      }
    }
  ].map((item: any) => ({ ...item, sortable: false }));

  const columns: Column[] = [
    {
      field: 'actions',
      headerName: 'Action',
      type: 'actions',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      getActions: (params: any) => {
        const actions = [
          <GridActionsCellItem
            key='delete'
            icon={
              <Icon
                icon='carbon:report'
                className='menu-icon view'
                style={{ color: '#FF4343' }}
              />
            }
            label={'Bookings'}
            onClick={() => {
              handleMenuClick(params.row);
              handleViewTrip(params.row);
            }}
            showInMenu
          />
        ];

        if (!roleAgent) {
          actions.push(
            <GridActionsCellItem
              key='edit'
              icon={<Icon icon='ic:baseline-edit' className='menu-icon update' />}
              label={constant.Update}
              onClick={() => {
                handleMenuClick(params.row);
                handleUpdateGroupTrip();
              }}
              showInMenu
            />
          );
        }

        return actions;
      }
    },

    { field: 'vehicleNumberUpper', headerName: 'Vehicle Number', minWidth: 200, flex: 1 },
    {
      field: 'tourName',
      headerName: 'Tour Name',
      minWidth: 260,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    {
      field: 'driverName',
      headerName: 'Driver Name',
      minWidth: 170,
      renderCell: (params: any) => {
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%'
            }}
          >
            {params.row.vehicleNumberUpper != 'Unassigned' && !roleAgent && (
              <Icon
                icon='ph:user-switch'
                style={{
                  color: '#0ebc93',
                  cursor: 'pointer',
                  fontSize: '25px',
                  marginRight: '10px'
                }}
                className={'activeIcon'}
                onClick={event => {
                  event.stopPropagation();
                  setIsDialog('changeDriver');
                  handleDriver(params.row);
                }}
              />
            )}
            <Typography>{params.value}</Typography>
          </Box>
        );
      },
      flex: 1
    },
    {
      field: 'driverContactNumber',
      headerName: 'Driver Contact Number',
      minWidth: 150,
      flex: 1
    },
    { field: 'pickupWindowView', headerName: 'Pickup Window', minWidth: 200, flex: 1 },
    { field: 'returnTimeView', headerName: 'Return Time', minWidth: 150, flex: 1 },
    { field: 'totalAdultCount', headerName: 'Adult Count', minWidth: 150, flex: 1 },
    { field: 'totalChildCount', headerName: 'Child Count', minWidth: 150, flex: 1 },
    { field: 'netCount', headerName: 'Total Count', minWidth: 150, flex: 1 }
  ].map((item: any) => ({ ...item, sortable: false }));

  useEffect(() => {
    const payload = {
      ...scheduledPayload,
      autoplannerID: scheduleDate,
      tripMode: 'SIC',
      PageNo: PageNo,
      PageSize: PageSize
    };
    if (checked) {
      dispatch(autoGeneratedTripsAction(payload));
      // dispatch(filterVehicleAction(payload));
    } else {
      dispatch(switchTripsAction(payload));
      // dispatch(filterVehicleAction(payload));
    }
  }, []);

  useEffect(() => {
    setPageNo(1);
    setPageSize(20);
  }, [checked]);

  useEffect(() => {
    if ((reportData as any)?.data?.standardTourBookingInfo?.length > 0) {
      const updatedList = (reportData as any)?.data?.standardTourBookingInfo.map(
        (item: any, index: number) => {
          const [startTime, endTime] = item?.pickupWindow
            ? item?.pickupWindow?.split('-')
            : '';
          return {
            ...item,
            id: item.id,
            vehicleNumberUpper: item.vehicleNumber.toUpperCase(),
            pickupWindowView: startTime
              ? `${convertTo12HourFormat(startTime)} - ${convertTo12HourFormat(endTime)}`
              : '-',
            returnTimeView: item.returnTime ? convertTo12HourFormat(item.returnTime) : '-'
          };
        }
      );
      setTripData(updatedList);
    } else {
      setTripData([]);
    }
  }, [reportData]);

  useEffect(() => {
    if (
      scheduledData.data !== null &&
      scheduledData.data.data !== null &&
      scheduledData?.data.data !== undefined
    ) {
      const scheduleList = (scheduledData as any)?.data?.data?.map(
        (item: any, index: number) => ({
          ...item,
          id: index + 1,
          isExternalVehicle: item.isExternalVehicle,
          vehicleNumber: item.externalVehicleView?.vehicleNumber
            ? item.externalVehicleView?.vehicleNumber
            : item?.vehicleNumber,
          driverName: item.externalVehicleView?.driverName
            ? item.externalVehicleView?.driverName
            : item?.driverName,
          driverID: item.externalVehicleView?.driverID
            ? item.externalVehicleView?.driverID
            : item?.driverId,
          mobileNumber: item.externalVehicleView?.mobileNumber
            ? item.externalVehicleView?.mobileNumber
            : item?.driverContactNumber,
          isExternalVehicles: item.externalVehicleView?.isExternalVehicle
            ? item.externalVehicleView?.isExternalVehicle
            : item?.isExternalVehicle,
          seatingCapacity: item.externalVehicleView?.seatingCapacity
            ? item.externalVehicleView?.seatingCapacity
            : item?.seatingCapacitys,
          isActive: item.externalVehicleView?.isActive
        })
      );
      setScheduleData(scheduleList);
    } else {
      setScheduleData([]);
    }
  }, [scheduledData]);

  useEffect(() => {
    if (data?.length > 0) {
      const switchList = data.map((item: any, index: number) => ({
        ...item,
        id: index + 1,
        totalCount: item.childCount + item.adultCount
      }));
      const vehicleNumbers = data?.map((item: any) => item.vehicleNumber);
      setVehicles(vehicleNumbers);
      setSwitchData(switchList);
    } else {
      setSwitchData([]);
      setVehicles([]);
    }
  }, [data]);

  useEffect(() => {
    setBreadCrumbs({
      setViews: setView,
      views: view
    });
  }, [view]);

  useEffect(() => {
    setPayload({ pageNo: PageNo, pageSize: PageSize });
  }, [PageNo, PageSize]);

  return (
    <Box>
      <CustomBreadcrumbs
        className='tracking-heading'
        itemOne={'Scheduled Tour'}
        itemTwo={'Bookings'}
        itemTwoState={view}
        setView={setView}
        handleItemOneClick={() => {
          if (view) {
            dispatch(autoGeneratedTripsAction(payload));
          }
        }}
      />

      {checked && (
        <Box>
          {(getAllLoading && tripData?.length == 0) ||
          (autoBookingsLoading && scheduleData?.length === 0) ? (
            <Box className='blue-circle-loader'>
              <Box className='blue-circle-spinner'></Box>
            </Box>
          ) : (reportData as any)?.data?.standardTourBookingInfo?.length > 0 && !view ? (
            <CustomDataGrid
              rows={tripData}
              onRowClick={(event: any, row) => {
                if (!roleAgent) {
                  handleUpdateGroupTrip();
                  setSelectedRow(row);
                }
              }}
              columns={columns}
              loading={getAllLoading}
              type={'noPageNation'}
              paginationMode={'client'}
            />
          ) : view ? (
            <CustomDataGrid
              rows={scheduleData}
              columns={Incolumns}
              onRowClick={(event: any, row) => {
                if (!roleAgent) {
                  handleUpdateTrip();
                  setSelectedTripRow(row);
                }
              }}
              loading={autoBookingsLoading}
              type={'noPageNation'}
              paginationMode={'client'}
            />
          ) : (
            <Box className='no-report-img'>
              <Box
                component={'img'}
                src={nodata}
                alt='No Report Found'
                className='no-report-found'
              />
            </Box>
          )}
        </Box>
      )}

      {!checked && (
        <Box>
          {switchTripLoading && switchData?.length === 0 ? (
            <Box className='blue-circle-loader'>
              <Box className='blue-circle-spinner'></Box>
            </Box>
          ) : data?.length > 0 || filter || isFilter || prevSearch ? (
            <Box>
              <Box sx={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                <Box sx={{ width: 200 }}>
                  <CustomTextField
                    name='search'
                    control={control}
                    id='filter-input'
                    placeholder='Search...'
                    value={filter}
                    variant='standard'
                    icon={<SearchOutlinedIcon color='primary' />}
                    onChangeCallback={(e: any) => handleFilterChange(e)}
                  />
                </Box>
              </Box>
              <CustomDataGrid
                rows={switchData}
                columns={switchColumns}
                loading={switchTripLoading}
                rowCount={count}
                onRowClick={(event: any, row) => {
                  if (!roleAgent) {
                    handleUpdateTrip();
                    setSelectedTripRow(row);
                  }
                }}
                type='logistics'
                onPaginationModelChange={handlePaginationModelChange}
                pageNo={PageNo}
                pageSize={PageSize}
                paginationModel={{
                  page: PageNo ? PageNo - 1 : 0,
                  pageSize: PageSize ? PageSize : 10
                }}
              />
            </Box>
          ) : (
            <Box className='no-report-img'>
              <Box
                component={'img'}
                src={nodata}
                alt='No Report Found'
                className='no-report-found'
              />
            </Box>
          )}
        </Box>
      )}

      {isUpdate && (
        <UpdateScheduleTrip
          filterPayload={filterPayload}
          isUpdate={isUpdate}
          setIsUpdate={setIsUpdate}
          selectedRow={selectedRow}
          autoplannerID={scheduleDate}
          tripMode='SIC'
        />
      )}
      {bookingUpdate && (
        <UpdateGeneratedTrip
          filterPayload={filterPayload}
          isOpen={bookingUpdate}
          setIsOpen={IsbookingsUpdate}
          selectedTripRow={selectedTripRow}
          setSelectedTripRow={setSelectedTripRow}
          selectedRow={selectedRow}
          autoplannerID={scheduleDate}
          pageDetail={{ pageNo: PageNo, pageSize: PageSize }}
          tripMode={'SIC'}
          Agents={agentNames}
          Routes={configuredRoute}
        />
      )}

      <Dialog
        open={
          isDialog === 'Delete' || isDialog === 'share' || isDialog === 'DeleteBooking'
        }
      >
        <Box
          sx={{
            textAlign: 'center',
            padding: '5%',
            minWidth: '350px'
          }}
        >
          <Typography>Are You Sure You Want To Delete the Trip</Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              paddingTop: '5%',
              justifyContent: 'center'
            }}
          >
            <Box sx={{ marginRight: '12px' }}>
              <CustomButton
                className='saveChanges'
                category='Yes'
                loading={isDialog === 'Delete' ? isLoading : deleteLoading}
                onClick={() => {
                  handleDelete();
                }}
              />
            </Box>
            <CustomButton
              className='cancel'
              category='No'
              onClick={() => setIsDialog('')}
            />
          </Box>
        </Box>
      </Dialog>

      <Dialog
        open={isDialog === 'Transfer'}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: 3,
            background: 'linear-gradient(to bottom, #ffffff, #f0f8ff)',
            boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
            overflow: 'hidden'
          }
        }}
      >
        <Box padding={3} width={400} position='relative'>
          <Box
            className='closeIcon icon-position d-flex close-icon-index'
            onClick={() => handleClose()}
          >
            <CustomIconButton category='CloseValue' />
          </Box>

          <Typography
            variant='h6'
            sx={{
              marginBottom: 2,
              fontWeight: 'bold',
              color: '#333',
              textAlign: 'center',
              textTransform: 'uppercase',
              borderBottom: '2px solid #007bff',
              paddingBottom: 1
            }}
          >
            Transfer Details
          </Typography>

          <Box sx={{ marginY: 2 }}>
            <Typography variant='body1' sx={{ fontSize: '1rem', color: '#555' }}>
              <strong>Transfer From:</strong>{' '}
              {transRow?.transferInstance?.from?.locationAddress}
            </Typography>
          </Box>

          <Box sx={{ marginY: 2 }}>
            <Typography variant='body1' sx={{ fontSize: '1rem', color: '#555' }}>
              <strong>Transfer To:</strong>{' '}
              {transRow?.transferInstance?.to?.locationAddress}
            </Typography>
          </Box>

          <Box sx={{ marginY: 2 }}>
            <Typography variant='body1' sx={{ fontSize: '1rem', color: '#555' }}>
              <strong>Total Count:</strong> {transRow?.transferInstance?.totalCount}
            </Typography>
          </Box>

          <Box sx={{ marginY: 2 }}>
            <Typography variant='body1' sx={{ fontSize: '1rem', color: '#555' }}>
              <strong>Driver Name:</strong> {transRow?.transferInstance?.driverName}
            </Typography>
          </Box>

          <Box sx={{ marginY: 2 }}>
            <Typography variant='body1' sx={{ fontSize: '1rem', color: '#555' }}>
              <strong>Contact Number:</strong> {transRow?.transferInstance?.contactNumber}
            </Typography>
          </Box>

          <Box sx={{ marginY: 2 }}>
            <Typography variant='body1' sx={{ fontSize: '1rem', color: '#555' }}>
              <strong>Vehicle Number:</strong>{' '}
              {transRow?.transferInstance?.vehicleNumber?.toUpperCase()}
            </Typography>
          </Box>
          <Box sx={{ ml: '280px' }}>
            <CustomButton
              className='saveChanges'
              category='Update'
              onClick={() => {
                handleUpdateTransfer();
              }}
            />
          </Box>
        </Box>
      </Dialog>
      <Dialog
        open={isDialog === 'changeDriver'}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: 3,
            background: 'linear-gradient(to bottom, #ffffff, #f0f8ff)',
            boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
            overflow: 'hidden'
          }
        }}
      >
        <Box
          padding={3}
          width={400}
          component={'form'}
          onSubmit={driverHandleSubmit(onChangeDriverSubmit)}
        >
          <Typography sx={{ fontWeight: '600', fontSize: '18px' }}>
            Change Driver
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginTop: '5px',
              marginRight: '10px'
            }}
          >
            <Typography>Changes only applicable for this tour</Typography>
            <Switch
              checked={only}
              onChange={handleChange}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          </Box>
          <CustomSelect
            id='driver'
            control={driverControl}
            name='driver'
            label='Driver Name'
            placeholder='Select Driver Name'
            options={dropDriver}
            loading={transferDrivers.isLoading}
          />
          <Box sx={{ textAlign: 'right', padding: '10px' }}>
            <CustomButton
              category='Cancel'
              className='cancel'
              sx={{ marginRight: '10px' }}
              onClick={() => handleClose()}
            />
            <CustomButton
              category={'Save'}
              className='saveChanges'
              type='submit'
              loading={driverLoading}
            />
          </Box>
        </Box>
      </Dialog>
      {isDialog === 'addTransfer' && (
        <AddExternalVehicle
          selectedRow={selectedTripRow}
          isDialog={isDialog}
          transRow={transRow}
          setTransRow={setTransRow}
          setAnchorEl={setAnchorEl}
          setIsDialog={setIsDialog}
          hotelLocationList={hotelLocationList}
          vehicleList={vehicleList}
          tripMode={'SIC'}
          scheduleDate={scheduleDate}
        />
      )}
    </Box>
  );
};

export default ScheduledSic;
